import  { SELECCIONAR_NUMCOMPROBANTE, SELECCIONAR_NUMCOMPROBANTEALTERNO } from './actionTypes';

export const seleccionar_NumeroComprobante = (numeroComprobante)=>{
	return {type: SELECCIONAR_NUMCOMPROBANTE,
			numeroComprobante
		};
}

export const seleccionar_NumeroComprobanteAlterno = (numeroComprobanteAlt)=>{
	return {type: SELECCIONAR_NUMCOMPROBANTEALTERNO,
            numeroComprobanteAlt
		};
}